import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2024" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        <EmptyTwo>
          <div className="entry-content">


            <h2>Transportation facilities in Xining</h2>
            <br></br>



            <h3>Xining Caojiabao International Airport</h3>
            <br />

            <p>
              <div className="title-center"
              >
                <img
                  src="./images/transportation/baoan.jpg"
                  width={1200}
                />

              </div>
            </p>
            <br />
            <p>
              Xining Caojiabao International Airport is located in Xining, the capital city of Qinghai Province in China. It is a modern and well-equipped airport that serves as a major transportation hub in the region. With its strategic location on the Qinghai-Tibet Plateau, the airport provides convenient access to various destinations in Qinghai Province and serves as a gateway for travelers visiting the Tibetan Plateau.
              <br></br>
              <br></br>
              The airport boasts a range of domestic and international flights, connecting Xining to major cities in China, including Beijing, Shanghai, Guangzhou, and Chengdu, as well as international destinations such as Kathmandu and Bangkok. It plays a crucial role in promoting tourism, business, and cultural exchanges between Qinghai and other regions.
              <br></br>
              <br></br>

              Xining Caojiabao International Airport offers modern facilities and services to ensure a comfortable and efficient travel experience. The terminal building features a blend of traditional Tibetan architectural elements and contemporary design, reflecting the unique cultural heritage of the region.
            </p>

            <p>
              For more information, please visit{" "}
              <a href="https://www.szairport.com/szairport/index.shtml">https://www.szairport.com/szairport/index.shtml</a>
            </p>

            <p>&nbsp;</p>
            <h3>Xining Railway Station</h3>
            <br />
            <div className="title-center">
              <img
                src="./images/transportation/shenzhenbei.jpg"
                width={650}
              />

            </div>
            <p>
              <br />
              Xining Railway Station, located in Xining, the capital city of Qinghai Province in China, is a major transportation hub in the region. As an important railway junction, it serves as a crucial gateway for travelers exploring the Qinghai-Tibet Plateau and connecting to other major cities in China.

              The railway station features modern infrastructure and facilities to accommodate the large number of passengers passing through it. It offers a comprehensive network of train services, including high-speed trains, express trains, and regular trains, connecting Xining to various destinations across China.

              The station&apos;s convenient location in the city center makes it easily accessible for both local residents and visitors. It is well-connected to public transportation, with buses, taxis, and other modes of transportation readily available for onward travel.
            </p>

            {/* <p>&nbsp;</p>
            <h3>Shenzhen Railway Station</h3>
            <br />
            <div className="title-center">
              <img
                src="./images/transportation/shenzhen.jpg"
                width={600}
              />

            </div>
            <p>
              <br />
              Shenzhen Railway Station, located in Luohu District, Shenzhen City, Guangdong Province, China, is a first-class station under the jurisdiction of China Railway Guangzhou Bureau Group Co., Ltd. It is also one of the departure and arrival stations of international trains.
            </p> */}


            <h2>Transportation to the venue</h2>
            <br></br>

            <h5>
              From Xining Caojiabao Airport:

            </h5>

            <b>Bus: </b>Take the combined route of Airport Bus Line 1/2 and then walk to the venue. (approximately 80 minutes).
            <br></br>
            <div className="title-center">

              <img
                src="./images/transportation/way1.png"
                alt="way1"
                width="55%"
              />

            </div>
            <br></br>
            <b>
              Taxi/Ride-Hailing Service:    </b>
            Take a taxi or ride-hailing service from the designated pick-up point at the airport to Qinghai Hotel (approximately 45 minutes).
            <br></br>
            <br></br>

            <h5>
              From Xining Railway Station:
            </h5>

            <b>Bus: </b> <ol>
              <li>Board the bus at Xining Railway Station (Platform ②).</li>
              <li>Take Bus No. 47 for 11 stops.</li>
              <li>Get off at Xinhua Alley Entrance (Xinhua Xiangkou) Station.</li>
            </ol>
            <br></br>
            <br></br>
            <div className="title-center">

              <img
                src="./images/transportation/way2.png"
                alt="way2"
                width="55%"
              />

            </div>
            <br></br>
            <b>Taxi/Ride-Hailing Service:</b> Take a taxi or ride-hailing service from the designated pick-up point at the railway station to Qinghai Hotel (approximately 15 minutes).

            <br></br>
            <br></br>




          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2023" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        <EmptyTwo>
          <UnderConstruction />
        </EmptyTwo>
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Transportation;
